export function HSAReimbursementCalculator() {
  return (
    <div className="not-prose my-8 rounded-xl border border-gray-200 p-6 text-center text-gray-400 text-sm">
      HSA Reimbursement Calculator — coming soon
    </div>
  )
}

export function HSAOpportunityCostCalculator() {
  return (
    <div className="not-prose my-8 rounded-xl border border-gray-200 p-6 text-center text-gray-400 text-sm">
      HSA Opportunity Cost Calculator — coming soon
    </div>
  )
}
